import openpathConfig from 'openpathConfig';

import { shouldSaveMissingToProduction } from './saveMissingEnvConfig';

/**
 * Determines which Locize version to save missing translations to.
 *
 * Save missing translations directly to Locize "production" only for approved
 * deploy environments.
 */
const getSaveMissingVersion = () => {
  // Save missing keys directly to production only for allowlisted environments
  if (shouldSaveMissingToProduction(openpathConfig.ENV)) {
    return 'production';
  }

  // Do not save missing keys from non-allowlisted environments
  return undefined;
};

const saveMissingVersion = getSaveMissingVersion();

// i18next-locize-backend by default only allows saving from localhost
// We need to explicitly allow active app hostnames when saveMissing is enabled
// This is REQUIRED - without it, saveMissing will not work even if saveMissing: true
const getAllowedHosts = () => {
  if (!shouldSaveMissingToProduction(openpathConfig.ENV)) {
    // For non-allowlisted environments, don't allow saving
    return undefined;
  }

  // Get current hostname if in browser context
  const currentHostname =
    typeof window !== 'undefined' ? window.location.hostname : null;

  // Allow localhost plus current hostname for environments where saveMissing is enabled
  const allowed = ['localhost', '127.0.0.1', 'helium.dev.openpath.com'];

  if (currentHostname && !allowed.includes(currentHostname)) {
    allowed.push(currentHostname);
  }

  return allowed;
};

const allowedHosts = getAllowedHosts();

export const locizeOptions = {
  projectId: openpathConfig.LOCIZE_PROJECTID,
  apiKey: openpathConfig.LOCIZE_APIKEY,
  version: openpathConfig.LOCIZE_VERSION,
  referenceLng: openpathConfig.LOCIZE_REFLNG,
  cdnType: 'pro',
  // CRITICAL: saveMissingTo tells Locize backend WHERE to save missing keys
  // Without this, saveMissing: true will not trigger any API calls
  ...(saveMissingVersion && { saveMissingTo: saveMissingVersion }),
  // CRITICAL: allowedAddOrUpdateHosts tells Locize backend WHICH hostnames are allowed
  // By default, it only allows localhost - if you're on a different host, saves are blocked
  // Without this, saveMissing: true will not trigger any API calls from non-localhost hosts
  ...(allowedHosts && { allowedAddOrUpdateHosts: allowedHosts }),
};
